import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { NotificationsOutlined, ArrowBackIosNew } from "@mui/icons-material";
import useNotifications from "../../features/Notification/useNotifications";
import NotificationItem from "./NotificationItem";
import InfiniteScroll from "../common/InfiniteScroll/InfiniteScroll";
import { useTranslation } from "react-i18next";

const NOTIF_SCROLL_ID = "notification-scroll-area";

const NotificationBell: React.FC = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const { notifications, loading, hasMore, loadMore, markRead, unreadCount } = useNotifications();

	return (
		<div className="relative">
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="relative flex h-full w-full items-center justify-center"
				aria-label={t("psdaCommon.notifications.title")}>
				<NotificationsOutlined sx={{ fontSize: 26 }} className="text-gray-900" />
				{unreadCount > 0 && (
					<span className="absolute right-0 top-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-medium leading-none text-white">
						{unreadCount > 99 ? "99+" : unreadCount}
					</span>
				)}
			</button>
			<Drawer
				anchor="right"
				open={open}
				onClose={() => setOpen(false)}
				PaperProps={{
					className: "max-w-md w-full bg-white shadow-2xl",
					sx: { borderTopLeftRadius: 12, borderBottomLeftRadius: 12 },
				}}>
				{/* Header */}
				<div className="flex items-center justify-between p-6 border-b h-[50px]">
					<IconButton onClick={() => setOpen(false)} className="!mr-2">
						<ArrowBackIosNew className="text-gray-500" />
					</IconButton>
					<h2 className="text-2xl font-bold text-gray-900 flex-1 text-center">{t("psdaCommon.notifications.title")}</h2>
					<span className="w-8" /> {/* Spacer for symmetry */}
				</div>
				{/* Notification List with Infinite Scroll */}
				<InfiniteScroll
					items={notifications || []}
					renderItem={item => <NotificationItem notification={item} markRead={markRead} setOpen={setOpen} />}
					isLoading={loading}
					isFetching={loading}
					hasNextPage={hasMore}
					fetchNextPage={loadMore}
					noDataMessage={t("psdaCommon.notifications.noNotifications")}
					className="p-4 space-y-3 max-h-[calc(100vh-70px)] overflow-y-auto"
					scrollRootId={NOTIF_SCROLL_ID}
				/>
			</Drawer>
		</div>
	);
};

export default NotificationBell;
